import { useTranslation } from 'react-i18next'

import { HtmlParser } from '@hozana/dom/components/HtmlParser'
import { TRACKING_SOURCE, UTM } from '@hozana/tracking/constants'

import { Div } from 'elements/layout/Div'
import { Space } from 'elements/layout/Space'
import { Icon } from 'elements/media/Icon'
import { P } from 'elements/text/P'
import { Alert } from 'elements/ui/Alert'

import { ICON } from 'config/icons'

import { TPrayerMeeting } from 'modules/meeting/types'
import { ShareCopy } from 'modules/share/components/ShareCopy'
import { ShareProvider } from 'modules/share/components/ShareProvider'
import { ShareSocial } from 'modules/share/components/ShareSocial'
import { SHARE_OBJECTS, SHARE_TYPES } from 'modules/share/constants'

import { TPrayerEvent } from '../../types'

type TPrayerMeetingInviteProps = {
  prayerEvent: TPrayerEvent
  prayerMeeting: TPrayerMeeting
}

export const PrayerMeetingInvite: TFC<TPrayerMeetingInviteProps> = ({ prayerEvent, prayerMeeting }) => {
  const { t } = useTranslation()

  return (
    <>
      <Alert hideCloseButton align="center">
        <Icon name={ICON.CHECK_DASH} m="0 10px 0 0" size="40px" />
        <P bold fontSize="18px" m="10px 0 0 0">
          {t('event:event.meeting-invite.you-participate-congrat')}
        </P>
      </Alert>
      <Space />
      <P fontSize="1em">
        <HtmlParser>
          {t('event:event.meeting-invite.organizerInfo', {
            organizer: `${prayerMeeting.organizerName} ${prayerMeeting.organizerSurname}`,
            prayerEventTitle: prayerEvent.title,
          })}
        </HtmlParser>
      </P>
      <Space />
      <P bold>trans:event:event.meeting-invite.propagate</P>
      <Space />
      <Div display="flex" align="betweenCenter">
        <ShareProvider
          objectToShare={SHARE_OBJECTS.PRAYER_MEETING}
          trackingSource={TRACKING_SOURCE.PRAYER_MEETING}
          prayerEvent={prayerEvent}
          prayerMeeting={prayerMeeting}
          utmContent={UTM.CONTENT.PRAYER_MEETING_SHARE_BUTTON}
        >
          <Div align="middleCenter" w="auto">
            <ShareSocial
              shareTypes={[SHARE_TYPES.WHATSAPP, SHARE_TYPES.MESSENGER, SHARE_TYPES.FACEBOOK, SHARE_TYPES.TWITTER]}
            />
            <ShareCopy m="5px" />
          </Div>
        </ShareProvider>
      </Div>
      <Space />
      {prayerEvent.communityId && <P bold>trans:event:event.meeting-invite.getPrepared</P>}
    </>
  )
}
